class InputProfile extends React.Component {

    constructor(props) {
        super(props);

        this.onChange = this.onChange.bind(this);
    }

    onChange(e) {
        this.props.onChange(this.props.field, e.target.value, this.props.address);
    }

    render() {
        var self = this,
        tabindex = this.props.tabindex || '';
        
        var isValid = true;
        if(!this.props.disabled && this.props.validate) {
            isValid = this.props.validate(this.props.value);
        }

        return (
            <div
                className={'input-profile' + (!isValid ? '__error ' : '' ) + (this.props.disabled ? '__disabled ' : '' ) + ' ' + this.props.className}>

                { this.props.title && 
                    <div className='input-profile__title'>
                        {this.props.title}
                    </div>
                }
                
                <input
                    type='text' 
                    disabled={this.props.disabled}
                    value={this.props.value}
                    onChange={this.onChange}
                    placeholder={this.props.placeHolder}
                    tabindex={tabindex} />

            </div>
        );
    }
}

export default InputProfile;



// WEBPACK FOOTER //
// ./ui_src/app/components/profile/view/InputProfile.react.jsx